import { Currency } from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";
import { WithGetAll } from "./mixins/WithGetAll";

export class Endpoint extends BaseEndpoint("currencies") {}

export const CurrencyEndpoint = WithGetAll<typeof Endpoint, Currency>(Endpoint);
